import styled from 'styled-components';
import type { CustomTheme } from '../../../@types/theme';

const breakpoint = (theme: CustomTheme) =>
  theme.type === 'legacy' ? theme.breakpoints.md : theme.breakpoints.lg;

export const FilterWrapper = styled.div`
  margin-inline: var(--page-margin);
  margin-bottom: ${({ theme }) => theme.spacing.fixed200};
`;

export const MobileFilterContainer = styled.div`
  @media (min-width: ${(props) => breakpoint(props.theme)}px) {
    display: none;
  }
`;

export const TagGroupContainer = styled.div`
  display: none;
  @media (min-width: ${(props) => breakpoint(props.theme)}px) {
    display: block;
  }
`;
